/* global globalThis */
import { supabase } from "../supabaseClient";
import { captureMessage } from "../utils/sentryUtils";

const inflight = new Map();

const warnFailure = (tournamentId, reason) => {
  console.warn("IndexNow notify failed", { tournamentId, reason });
  try {
    captureMessage(`IndexNow notify failed (${reason})`, "warning", {
      extra: { tournamentId, reason },
    });
  } catch (error) {
    console.warn("IndexNow Sentry warning failed", error);
  }
};

const sendIndexNow = async (tournamentId) => {
  const { data, error } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (error || !token) {
    warnFailure(tournamentId, "unauthorized");
    return { notified: false, reason: "unauthorized" };
  }

  const response = await globalThis.fetch("/api/indexnow", {
    method: "POST",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ tournamentId }),
  });

  let body = {};
  try {
    body = await response.json();
  } catch {
    body = {};
  }

  const reason = body?.reason || (response.ok ? "" : `http_${response.status}`);
  if (!response.ok || body?.notified === false) {
    if (reason && reason !== "not_public" && reason !== "no_urls") {
      warnFailure(tournamentId, reason);
    }
    return {
      notified: false,
      reason: reason || "indexnow_error",
    };
  }

  return { notified: true, reason, count: body?.count };
};

export const requestTournamentIndexNow = (tournamentId) => {
  try {
    const id = String(tournamentId || "").trim();
    if (!id) return Promise.resolve({ notified: false, reason: "no_id" });

    const existing = inflight.get(id);
    if (existing) return existing;

    const job = sendIndexNow(id)
      .catch(() => {
        warnFailure(id, "indexnow_error");
        return { notified: false, reason: "indexnow_error" };
      })
      .finally(() => {
        if (inflight.get(id) === job) inflight.delete(id);
      });
    inflight.set(id, job);
    return job;
  } catch (error) {
    console.warn("IndexNow notify failed", error);
    return Promise.resolve({ notified: false, reason: "indexnow_error" });
  }
};
